import React from "react";
import { Section, SectionHeading, SectionLabel } from "../ui";
import { PROBLEMS } from "../content";

export default function ProblemSection() {
  return (
    <Section>
      <div className="tw-grid tw-grid-cols-[.82fr_1.18fr] tw-items-start tw-gap-12 sm:tw-grid-cols-1">
        <div className="tw-sticky tw-top-32 sm:tw-static">
          <SectionLabel>Where programmes stall</SectionLabel>
          <SectionHeading>
            Most organisations believe in mentoring. Few can run it at scale.
          </SectionHeading>
          <p className="tw-mt-6 tw-mb-0 tw-text-lg tw-leading-8 tw-text-[#5b7188]">
            Spreadsheets and calendar links can manage a few pairs. Once a programme grows, HR becomes
            the reminder system, helpdesk and reporting engine.
          </p>
        </div>

        <div className="tw-grid tw-gap-4">
          {PROBLEMS.map((problem) => (
            <article
              key={problem.number}
              className="tw-grid tw-grid-cols-[64px_1fr] tw-gap-5 tw-border-t tw-border-[#cfdeeb] tw-py-7 xs:tw-grid-cols-1 xs:tw-gap-2"
            >
              <span className="tw-text-sm tw-font-black tw-text-[#0068b8]">{problem.number}</span>
              <div>
                <h3 className="tw-m-0 tw-text-xl tw-font-black tw-tracking-[-.02em] tw-text-[#1c3854]">
                  {problem.title}
                </h3>
                <p className="tw-mt-2 tw-mb-0 tw-max-w-2xl tw-leading-7 tw-text-[#5b7188]">
                  {problem.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </Section>
  );
}
